module.exports = __webpack_public_path__ + "static/media/safety-reman-1.665e6f0f.png";